export const MASK_VALUE_DEFAULT = '**/**/****';
